<template>
  <div>
    <ask
      @ok="processPaymentSchedule(true)"
      ref="noApproval"
      title="Start without Authorization"
      message="Are you sure you would like to start this payment plan without the patient's signed authorization?"
    ></ask>

    <b-modal
      ref="review"
      lazy
      size="xl"
      hide-footer
      aria-label=""
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
    >
      <template #modal-title="{ close }">
        <div>
          Payment Plan for {{ customer.firstName }} {{ customer.lastName }}
        </div>
      </template>

      <div v-if="renderView">
        <payment-plan-preview
          :paymentPlan="paymentPlan"
          :customer="customer"
          :form="form"
          :methodSelected="methodSelected"
          :approved="approved"
          @paymentPlanUpdated="paymentPlanUpdated"
        ></payment-plan-preview>

        <!--<div v-show="state == 'printandsign'" style="width:500px;">
            <hr />
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Please review and sign below
            </h6>

            <h5 class="h3 mb-4">Terms and Conditions</h5>

            <div style="white-space:pre-wrap">{{ template }}</div>
            <br /><br />
            <div style="border-bottom:solid 1px gray" class="pt-4">
              <i class="fas fa-sign-in"></i>
            </div>
            <div>
              {{ customer.firstName }} {{ customer.lastName }} -
              {{ new Date().toLocaleDateString("en-US") }}
            </div>
          </div>
        </div>-->

        <b-row class="m-0" v-if="state == 'ready' && !approved && template">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <hr />

            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Payment Plan Review & Authorization
            </h6>
            <h5 class="h3 mb-4">Electronic Signature</h5>

            <base-input-phone v-model="copiedCell" prependIcon="fa fa-mobile">
              <template #appendButton>
                <b-button
                  class="btn btn-outline-primary shadow-none"
                  variant="primary"
                  :disabled="!copiedCell"
                  @click="emailAndApprove"
                >
                  <i class="fa-solid fa-signal-stream"></i>
                  &#160; Send
                </b-button>
              </template>
            </base-input-phone>
          </b-col>
        </b-row>

        <b-row class="m-0" v-if="state == 'waiting'">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <hr />

            <div>
              <div class="row">
                <div class="col-3" style="text-align:center">
                  <img
                    style="width:100px;margin-left:20px"
                    src="@/assets/img/signature.gif"
                  />
                  <br /><br />
                  <a href="#" @click.prevent="cancelSignature">Cancel</a>
                </div>
                <div class="col-9">
                  <h3>
                    Waiting for Patient Authorization...
                  </h3>
                  <p class="text-muted">
                    A text message has been sent to
                    {{ copiedCell | phone }}. You can start the payment plan as
                    soon as the patient completes their authorization.
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="m-0" v-if="state == 'approved'">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <hr />
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Payment Plan Review & Authorization
            </h6>
            <h5 class="h3 text-success">
              <i
                v-b-tooltip.hover
                title="Signed"
                class="fa-solid fa-badge-check text-success"
              ></i>
              Authorization Completed
            </h5>

            <template v-if="approved.approvalIPAddress">
              <div
                class="mt-2 p-2"
                style="border: dotted 1px #ccc; display: inline-block;"
              >
                <img :src="approved.approvalSignature" height="125" />
              </div>
            </template>
          </b-col>
        </b-row>

        <b-row class="m-0">
          <b-col class="pl-5 pr-5 pb-5 pt-0 m-0 mt--4">
            <b-button
              class="btn-block"
              variant="primary"
              @click="processPaymentSchedule(approved || !template)"
              ><template v-if="!approved && template"
                >Start Plan without Authorization</template
              ><template v-else>Start Payment Plan</template></b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <div>
      <validation-observer ref="reviewForm" v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(onReview)">
          <b-row>
            <b-col sm="6">
              <customer-saved-cards
                v-on:onCustomerCardSelect="onCustomerCardSelect"
                :customer="customer"
              ></customer-saved-cards>
            </b-col>
            <b-col sm="6">
              <label class="form-control-label" for="example-datepicker"
                >Date of First Payment</label
              >
              <b-form-datepicker
                v-model="form.startDate"
                value-as-date
                class="col-sm-12"
                :min="new Date()"
              ></b-form-datepicker>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="12" lg="6">
              <b-row>
                <b-col cols="6">
                  <base-input-currency
                    class="mb-3"
                    name="Payment Amount"
                    ref="paymentAmount"
                    rules="required|money"
                    label="Payment Plan Total"
                    v-model="form.paymentAmount"
                  >
                  </base-input-currency>
                </b-col>

                <b-col cols="6">
                  <base-input-currency
                    class="mb-3"
                    name="Down Payment"
                    ref="downPayment"
                    rules="moneyZeroOk"
                    mode="lazy"
                    label="Down Payment"
                    v-model="form.downPayment"
                  >
                  </base-input-currency>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" lg="6">
              <b-row>
                <b-col>
                  <base-input
                    name="Number Of Payments"
                    ref="numberOfPayments"
                    mode="lazy"
                    class="w-100"
                    rules="required|integer"
                    label="Number of Payments"
                    v-model="form.numberOfPayments"
                  >
                  </base-input>
                </b-col>
                <b-col style="margin-top: 32px">
                  <b-form-select
                    v-model="form.cycleType"
                    :options="cycleTypeOptions"
                    class="form-control"
                  ></b-form-select>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div style="width: 100%; text-align: right">
            <b-button type="submit" variant="primary" class="btn-block mt-4"
              >Review Payment Plan</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </div>
    <br />
  </div>
</template>

<style>
.card {
  font-size: 1rem;
}

.icon-status-approved {
  font-size: 0.9em;
  position: relative;
  top: 1px;
}
</style>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import swal from "sweetalert2";

import CustomerSavedCards from "@/views/Components/CustomerSavedCards";
import PaymentPlanPreview from "./PaymentPlanPreview";
import * as signalR from "@microsoft/signalr";
import { Printd } from "printd";

export default {
  name: "payment-plan",
  props: { customer: null },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    CustomerSavedCards,
    "payment-plan-preview": PaymentPlanPreview,
  },

  data: function() {
    return {
      startDateOptions: [
        { text: "Process now", value: "NOW" },
        { text: "Start date", value: "STARTDATE" },
      ],
      state: "ready",
      freq: "month",
      renderView: false,
      connection: null,
      template: null,

      todayDate:
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear(),

      hasDownPayment: false,
      approved: null,
      copiedCell: null,
      startDateChanged: false,
      form: {
        customerId: null,
        customerSavedCardId: null,
        paymentAmount: null,
        downPayment: null,
        numberOfPayments: 12,
        cycleType: "month",
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
      },
      cycleTypeOptions: [
        { value: "week", text: "Weekly" },
        { value: "biweek", text: "Biweekly" },
        { selected: true, value: "month", text: "Monthly" },
        { value: "year", text: "Yearly" },
      ],
      patientCards: [],
      paymentPlan: [],
    };
  },
  created() {
    var self = this;

    if (self.customer && self.customer.balance) {
      if (self.customer.balance > 0)
        this.form.paymentAmount = self.customer.balance;
    } else {
      this.$refs.paymentAmount.$el.querySelector("input").focus();
    }
  },
  beforeDestroy() {
    this.disconnectHub();
  },

  methods: {
    startWithDownPaymentOptions() {
      localStorage.startWithDownPaymentOptions = true;
      this.hideStartWithDownPaymentOption = true;
      this.$emitter.emit("success", { message: "Alright, I'll remember." });
    },

    toggleArithmetic() {
      if (this.form.arithmetic == "-") this.form.arithmetic = "+";
      else this.form.arithmetic = "-";

      localStorage.paymentPlanArthimetic = this.form.arithmetic;
    },
    cancelSignature() {
      this.disconnectHub();
      this.state = "ready";
    },
    paymentPlanUpdated(pp) {
      this.paymentPlan = pp;
    },
    setCellPhone() {
      this.$refs.review.hide();
      this.$emit("editPatient");
    },
    disconnectHub() {
      this.connection.stop();
    },
    cancelEmail() {
      try {
        this.disconnectHub();
      } catch {}
      this.$refs.sendingEmail.hide();
    },
    async emailAndApprove() {
      var self = this;
      this.state = "waiting";
      self.form.customerId = self.customer.id;
      self.form.customerSavedCardId = self.methodSelected.id;

      let o = {
        ...this.form,
        cell: this.copiedCell,
        schedule: this.paymentPlan.scheduleItems,
        processingToday: this.paymentPlan.processingToday,
        isDown: this.paymentPlan.isDown,
        isFirstPayment: this.paymentPlan.isFirstPayment,
      };

      var r = await self.$client.post(
        "/api/paymentPlan/sendTextConfirmation",
        o
      );

      if (r.data.isSuccess) {
        console.log(r.data.value.url);

        this.connection = new signalR.HubConnectionBuilder()
          .withUrl(
            r.data.value.patientPortalUri +
              "/signalr?coalesceId=" +
              r.data.value.coalesceId
          )
          .configureLogging(signalR.LogLevel.Information)
          .withAutomaticReconnect()
          .build();

        await this.connection.start();

        this.connection.on("approved", (message) => {
          self.approved = {
            approvalMethod: this.$options.filters.phonenumber(this.copiedCell),
            approvalIPAddress: message.ipAddress,
            approvalSignature: message.signature,
          };
          this.state = "approved";
          swal
            .fire({
              title: "Authorization Completed",
              text:
                "The payment plan has been reviewed and authorized by the patient. You can now start the payment plan.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then((e) => {});
          this.disconnectHub();
        });
      }
    },
    async print() {
      var self = this;
      self.state = "printandsign";

      await this.$nextTick();

      const cssText = `
        h1 {
          color: black;
          font-family: sans-serif;
        }

        html {
          font-size:10px;
        }

        .vertical-center {
        min-height: 100%;  /* Fallback for browsers do NOT support vh unit */
        min-height: 100vh; /* These two lines are counted as one :-)       */

        display: flex;
        align-items: center;
      }
      `;

      const d = new Printd();

      d.print(
        document.getElementById("printDiv"),
        [
          cssText,
          "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css",
        ],
        null,
        function({ launchPrint }) {
          launchPrint();
          self.state = "ready";
          self.approved = {
            method: "Print & Sign",
            name: localStorage.getItem("name"),
          };
        }
      );
    },
    onCustomerCardSelect(patientCard) {
      this.methodSelected = patientCard;
    },
    async processPaymentSchedule(dontAskForConfirmation) {
      if (dontAskForConfirmation) {
        var self = this;

        self.form.customerId = self.customer.id;
        self.form.customerSavedCardId = self.methodSelected.id;
        self.form.approval = self.approval;

        var r = await self.$client.post("/api/paymentplan/addPaymentPlan", {
          ...self.approved,
          ...self.form,
          scheduleItems: this.paymentPlan.scheduleItems,
        });

        if (r.data.isSuccess) {
          if (r.data.value.isApproved) {
            swal
              .fire({
                title: "Payment Plan Created",
                text: r.data.value.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success",
                icon: "success",
              })
              .then((e) => {
                self.$router.push({ name: "Dashboard" });
              });
          } else {
            if (!r.data.value.isApproved) {
              swal
                .fire({
                  title: "Declined",
                  text:
                    "The initital payment was declined because " +
                    r.data.value.message +
                    "\r\n\r\nThe payment plan was not created.",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-danger",
                  icon: "error",
                })
                .then((e) => {
                  self.$refs.review.hide();
                });
            }
          }
        }
      } else {
        this.$refs.noApproval.ask();
      }
    },

    makeChanges() {
      var self = this;
    },
    async onReview() {
      if (
        parseFloat(this.form.paymentAmount) <= parseFloat(this.form.downPayment)
      ) {
        this.$emitter.emit(
          "error",
          "The payment plan total must be greater than the down payment"
        );
        return;
      }

      var self = this;
      self.state = "ready";
      self.approved = null;
      self.form.customerId = self.customer.id;
      self.form.customerSavedCardId = self.methodSelected.id;
      self.copiedCell = self.customer.cell;

      if (!self.form.downPayment) self.form.downPayment = null;

      var r = await self.$client.post("/api/paymentPlan/generateSchedule", {
        ...this.form,
      });

      r.data.value.scheduleItems.forEach((e) => {
        e.isEdit = false;
        e.isEditDate = false;
        e.amountDueConverted = e.amountDue / 100;
      });

      self.renderView = true;
      self.template = r.data.value.template;
      self.paymentPlan = r.data.value;
      self.$refs.review.show();
    },
  },
};
</script>
